import { render, staticRenderFns } from "./alerta.component.vue?vue&type=template&id=5a1cd0b6&"
import script from "./alerta.component.vue?vue&type=script&lang=js&"
export * from "./alerta.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/webroot/appsobdemanda/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1cd0b6')) {
      api.createRecord('5a1cd0b6', component.options)
    } else {
      api.reload('5a1cd0b6', component.options)
    }
    module.hot.accept("./alerta.component.vue?vue&type=template&id=5a1cd0b6&", function () {
      api.rerender('5a1cd0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/alerta.component.vue"
export default component.exports